(function () {
  var root = document.documentElement;
  var STORAGE = "vye-b2-flavour";
  var FLAVOUR_SCENE = {
    mint: ["Mint", "VYE Mist, Mint flavour"],
    citrus: ["Citrus", "VYE Mist, Citrus flavour"],
    berry: ["Berry", "VYE Mist, Berry flavour"],
    unflavoured: ["Unflavoured", "VYE Mist, Unflavoured"],
    spearmint: ["Mint", "A hand holding fresh spearmint against a bright mint background"],
    lemonlime: ["Citrus", "A hand gently holding lemon and lime against a bright lime background"],
    mixedberry: ["Berry", "A hand full of mixed berries against a purple background"]
  };

  function flavourName(key) {
    var el = document.querySelector("[data-flavour-name][data-flavour=\"" + key + "\"]");
    if (el) return el.getAttribute("data-flavour-name");
    var card = document.querySelector("[data-flavour=\"" + key + "\"] .flav__name, [data-flavour=\"" + key + "\"] .swatch__name");
    if (card) return card.innerText.replace(/\s+/g, " ").trim();
    return key;
  }

  function currentFlavour() {
    return root.dataset.flavour || "mint";
  }

  function productHref(extra) {
    var base = document.querySelector("[data-vye-product-url]");
    var url = new URL((base && base.getAttribute("data-vye-product-url")) || "/products/vye-mist", window.location.origin);
    var q = new URLSearchParams(extra || {});
    q.set("flavour", currentFlavour());
    url.search = q.toString();
    return url.pathname + url.search;
  }

  function syncProductLinks() {
    document.querySelectorAll("[data-vye-product-link]").forEach(function (a) {
      a.href = productHref();
    });
  }

  function paint(key, sourceEl, persist) {
    if (!key) return;
    root.dataset.flavour = key;
    // Flavour cards are links, so the highlight is a data attribute (aria-pressed is button-only).
    document.querySelectorAll(".flav[data-flavour]").forEach(function (b) {
      b.toggleAttribute("data-active", b.dataset.flavour === key);
    });
    document.querySelectorAll(".swatch[data-flavour]").forEach(function (b) {
      b.setAttribute("aria-pressed", b.dataset.flavour === key ? "true" : "false");
    });
    var name = flavourName(key);
    document.querySelectorAll("[data-vye-flavour-label]").forEach(function (el) {
      el.textContent = name;
    });
    var pill = document.querySelector('.swatch[data-flavour="' + key + '"]');
    var note = pill ? pill.getAttribute("data-flavour-note") || "" : "";
    document.querySelectorAll("[data-vye-flavour-note]").forEach(function (el) {
      el.textContent = note;
      el.hidden = !note;
    });
    var scene = FLAVOUR_SCENE[key] || FLAVOUR_SCENE.mint;
    document.querySelectorAll(".flavour-scene__photo").forEach(function (el) {
      el.setAttribute("aria-label", scene[1]);
      if (sourceEl) el.classList.remove("is-lazy-bg");
      var custom = el.getAttribute("data-flavour-src-" + key);
      if (custom) {
        el.style.backgroundImage = "url(" + custom + ")";
        el.classList.add("is-custom-flavour");
      } else {
        el.style.backgroundImage = "";
        el.classList.remove("is-custom-flavour");
      }
    });
    document.querySelectorAll("[data-vye-hero-product]").forEach(function (img) {
      var suffixMap = { mint: "spearmint", citrus: "lemonlime", berry: "mixedberry", unflavoured: "spearmint", unflavored: "spearmint" };
      var imageKey = suffixMap[key] || key;
      var next = img.getAttribute("data-src-" + imageKey);
      if (next && img.getAttribute("src") !== next) {
        img.src = next;
        img.alt = img.getAttribute("data-alt-" + imageKey) || "VYE nicotine mist held in a hand against its flavour colour.";
        img.style.objectPosition = img.getAttribute("data-position-" + imageKey) || "center";
      }
    });
    if (persist !== false) {
      try { window.localStorage.setItem(STORAGE, key); } catch (e) {}
    }
    syncProductLinks();
    document.dispatchEvent(new CustomEvent("vye-b2:flavour", { detail: { key: key, source: sourceEl || null } }));
  }

  function setCartCount(n) {
    document.querySelectorAll("[data-vye-cart-count]").forEach(function (el) {
      el.textContent = String(n);
    });
  }

  function openCartDrawer() {
    var drawer = document.querySelector("cart-drawer-component");
    // Browsers without <dialog> (older Safari) can't open the drawer; use the cart page.
    if (typeof HTMLDialogElement === "undefined" || typeof HTMLDialogElement.prototype.showModal !== "function") {
      window.location.href = "/cart";
      return;
    }
    if (drawer && typeof drawer.open === "function") {
      drawer.open();
      return;
    }
    var trigger = document.querySelector("[data-testid=\"cart-drawer-trigger\"]");
    if (trigger) trigger.click();
  }

  window.VYE_B2 = window.VYE_B2 || {};
  window.VYE_B2.paint = paint;
  window.VYE_B2.currentFlavour = currentFlavour;
  window.VYE_B2.productHref = productHref;
  window.VYE_B2.openCartDrawer = openCartDrawer;
  window.VYE_B2.setCartCount = setCartCount;

  document.querySelectorAll("[data-vye-cart]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      openCartDrawer();
    });
  });

  document.querySelectorAll(".flav[data-flavour]").forEach(function (btn) {
    btn.addEventListener("pointerenter", function () { paint(btn.dataset.flavour, btn, false); });
    btn.addEventListener("focus", function () { paint(btn.dataset.flavour, btn, false); });
    btn.addEventListener("click", function () { paint(btn.dataset.flavour, btn, true); });
  });

  document.querySelectorAll(".swatch[data-flavour]").forEach(function (btn) {
    btn.addEventListener("click", function () { paint(btn.dataset.flavour, btn); });
  });

  var params = new URLSearchParams(window.location.search);
  var start = params.get("flavour");
  // A direct Shopify variant link takes precedence over a remembered flavour.
  if (!start && params.get('variant')) {
    var linkedVariant = Array.from(document.querySelectorAll('.swatch[data-waitlist-variant]')).find(function (button) {
      return button.dataset.waitlistVariant === params.get('variant');
    });
    if (linkedVariant) start = linkedVariant.dataset.flavour;
  }
  var onHome = document.body.classList.contains("template-index");
  if (!start && !onHome) {
    try { start = window.localStorage.getItem(STORAGE); } catch (e) {}
    if (start && window.VYE_B2_PRODUCT && window.VYE_B2_PRODUCT.byOption) {
      var sw = document.querySelector('.swatch[data-flavour="' + start + '"]');
      var opt = sw && sw.getAttribute("data-variant-option");
      var v = opt && window.VYE_B2_PRODUCT.byOption[opt];
      if (!v || !v.available) start = window.VYE_B2_PRODUCT.defaultFlavour || null;
    }
  }
  if (start) paint(start, null, !!params.get("flavour"));
  else {
    if (onHome) paint("mint", null, false);
    else paint(currentFlavour(), null, false);
  }

  document.querySelectorAll("[data-vye-nav-toggle]").forEach(function (toggle) {
    var drawer = document.getElementById(toggle.getAttribute("aria-controls"));
    if (!drawer) return;
    toggle.addEventListener("click", function () {
      var open = drawer.dataset.open === "true";
      drawer.dataset.open = String(!open);
      toggle.setAttribute("aria-expanded", String(!open));
      toggle.textContent = open ? (toggle.dataset.labelMenu || "Menu") : (toggle.dataset.labelClose || "Close");
    });
    drawer.addEventListener("click", function (e) {
      if (e.target.tagName !== "A") return;
      drawer.dataset.open = "false";
      toggle.setAttribute("aria-expanded", "false");
      toggle.textContent = toggle.dataset.labelMenu || "Menu";
    });
  });

  function sizeMarquees() {
    document.querySelectorAll(".marquee").forEach(function (el) {
      var group = el.querySelector(".marquee__group");
      if (!group) return;
      el.style.setProperty("--marquee-shift", group.getBoundingClientRect().width + "px");
    });
  }
  sizeMarquees();
  window.addEventListener("resize", sizeMarquees);

  var lazyScenes = document.querySelectorAll(".flavour-scene__photo.is-lazy-bg");
  if (lazyScenes.length) {
    if ("IntersectionObserver" in window) {
      var bgIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.remove("is-lazy-bg"); bgIo.unobserve(e.target); }
        });
      }, { rootMargin: "600px 0px" });
      lazyScenes.forEach(function (el) { bgIo.observe(el); });
    } else {
      lazyScenes.forEach(function (el) { el.classList.remove("is-lazy-bg"); });
    }
  }

  document.querySelectorAll("[data-vye-accordion]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var panel = btn.nextElementSibling;
      if (!panel) return;
      var open = panel.dataset.open === "true";
      var rootAcc = btn.closest("[data-vye-accordion-root]") || document;
      rootAcc.querySelectorAll(".acc-panel").forEach(function (p) { p.dataset.open = "false"; });
      rootAcc.querySelectorAll("[data-vye-accordion]").forEach(function (b) {
        b.setAttribute("aria-expanded", "false");
        var mark = b.querySelector("[data-vye-acc-mark]");
        if (mark) mark.textContent = "+";
      });
      if (!open) {
        panel.dataset.open = "true";
        btn.setAttribute("aria-expanded", "true");
        var mark = btn.querySelector("[data-vye-acc-mark]");
        if (mark) mark.textContent = "–";
      }
    });
  });
})();

/* Light motion: the six droplets pop in, the 30-second dial runs with the
   scroll, photo tiles marked for parallax drift inside their frames, layered
   tiles move each cut-out at its own depth, the hero hand and ticker answer
   the scroll, and flavour cards and How it works steps arrive in turn.
   Skipped for reduced motion and in the theme editor, where everything shows
   in its finished state. */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  if (!window.matchMedia("(prefers-reduced-motion: no-preference)").matches) return;

  function init() {
    // Droplets pop on the same scroll position as the 30-second dial, so they
    // land with the number instead of ahead of it (see frame below).
    var pops = Array.prototype.slice.call(document.querySelectorAll("[data-vye-pop]"));
    if (pops.length) {
      if ("IntersectionObserver" in window) {
        var popIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add("has-drops"); popIo.unobserve(e.target); }
          });
        }, { rootMargin: "600px 0px" });
        pops.forEach(function (el) { popIo.observe(el); });
      } else {
        pops.forEach(function (el) { el.classList.add("has-drops"); });
      }
    }

    var dials = Array.prototype.map.call(document.querySelectorAll("[data-vye-dial]"), function (el) {
      var n = el.querySelector("[data-vye-dial-n]");
      return { el: el, n: n, to: n ? parseFloat(n.textContent) || 30 : 30 };
    });
    var tiles = document.querySelectorAll(".tile--parallax, .tile--layers");

    // Flavour cards rise in; How it works steps arrive in order.
    var reveals = document.querySelectorAll(".rail--rise, .how--steps-in");
    if (reveals.length && "IntersectionObserver" in window) {
      var ro = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add("is-in"); ro.unobserve(e.target); }
        });
      }, { threshold: 0.3 });
      reveals.forEach(function (el) { el.classList.add("is-armed"); ro.observe(el); });
    }

    // The hero hand sinks behind the ticker as you scroll away, and the ticker
    // speeds up while you scroll, then settles.
    var heroImg = document.querySelector(".hero--motion .hero__media img");
    var track = document.querySelector("[data-ticker-scroll] .marquee__track");
    var tickerAnim = track && track.getAnimations ? track.getAnimations()[0] : null;
    var lastY = window.scrollY, rate = 1;

    var ticking = false;
    function frame() {
      ticking = false;
      var vh = window.innerHeight, y = window.scrollY;
      if (heroImg && y < vh * 1.5) heroImg.style.setProperty("--hy", (Math.min(y, 900) * 0.18).toFixed(1) + "px");
      if (tickerAnim) {
        var want = 1 + Math.min(Math.abs(y - lastY) / 12, 4);
        rate += (want - rate) * 0.15;
        if (Math.abs(rate - 1) < 0.02) rate = 1;
        tickerAnim.playbackRate = rate;
        if (rate !== 1) request();
      }
      lastY = y;
      var lead = null; // the first dial's progress, which the droplets follow
      dials.forEach(function (d) {
        var r = d.el.getBoundingClientRect();
        // Runs from when the dial enters at the bottom until it reaches 30% up
        // the screen, or until the speed stage pins, whichever comes first.
        var span = vh * 0.7;
        var stage = d.el.closest(".speed-scene.is-scrub > .speed-scene__stage");
        if (stage) span = Math.min(span, stage.getBoundingClientRect().bottom - r.top);
        var p = Math.min(Math.max((vh - r.top) / Math.max(span, 1), 0), 1);
        if (lead === null) lead = p;
        d.el.style.setProperty("--p", (p * 0.5).toFixed(4));
        if (d.n) d.n.textContent = String(Math.round(p * d.to));
      });
      pops.forEach(function (el) {
        if (el.classList.contains("is-in")) return;
        // Pops once the dial reaches the halfway point of its run, so the drops
        // land with the clock. Without a dial, it uses the graphic's own position.
        var p = lead;
        if (p === null) p = (vh - el.getBoundingClientRect().top) / (vh * 0.7);
        if (p >= 0.5) el.classList.add("is-in");
      });
      tiles.forEach(function (t) {
        var r = t.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        // -1 when the tile enters at the bottom, 1 when it leaves at the top.
        var p = (vh / 2 - (r.top + r.height / 2)) / (vh / 2 + r.height / 2);
        t.style.setProperty("--py", (p * r.height * 0.05).toFixed(1) + "px");
        t.style.setProperty("--pp", p.toFixed(4));
      });
    }
    function request() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener("scroll", request, { passive: true });
    window.addEventListener("resize", request);
    frame();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
